import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { useIntl } from "react-intl";
import Section from "../Section";
import { PendingButton } from "@ploy-ui/core";
import { Grid, DialogContent, Dialog, DialogActions, DialogTitle, Button } from "@material-ui/core";
import { useCalculation, useTemplateDebugManager } from "@ploy-lib/calculation";
import { useFormikContext, getIn } from "formik";
import { getFieldName } from "@ploy-lib/core";
addRegisteredSectionLayout({
    name: "DialogSection",
    displayName: "DialogSection",
    settings: {
        editableOptions: { showDialogButtons: true, fullWidthOpenButton: true }
    }
});
const messages = {
    closeDialogButtonLabel: {
        id: "dialogSection.close.button",
        defaultMessage: "Lukk",
        description: "label of close modal button"
    }
};
const DialogSection = (props) => {
    const { sectionTitle, showDialogButtons, fullWidthOpenButton, ...rest } = props;
    const { className, onClick } = rest;
    const intl = useIntl();
    const { enabled: debugEnabled } = useTemplateDebugManager();
    const { errors } = useCalculation("errors");
    const { errors: formikErrors, touched: formikTouched } = useFormikContext();
    const [sectionError, setSectionError] = useState(false);
    const [isOpen, setOpen] = useState(!debugEnabled && !showDialogButtons);
    useEffect(() => {
        if (props.fields.some(field => {
            const name = getFieldName(field);
            const touched = getIn(formikTouched, name);
            const error = getIn(formikErrors, name);
            return touched && error;
        })) {
            setSectionError(true);
            setOpen(true);
        }
        else {
            setSectionError(false);
        }
    }, [
        formikErrors,
        formikTouched,
        errors,
        props.fields,
        setSectionError,
        setOpen
    ]);
    const onClickHandler = () => setOpen(true);
    const onCloseHandler = () => setOpen(false);
    return (_jsxs(_Fragment, { children: [showDialogButtons && (_jsx(Grid, { container: true, justifyContent: "center", spacing: 2, children: _jsx(Grid, { item: true, xs: fullWidthOpenButton ? 12 : undefined, className: className, onClick: onClick, children: _jsx(PendingButton, { fullWidth: fullWidthOpenButton, pending: false, size: "large", variant: "contained", color: "secondary", onClick: onClickHandler, children: sectionTitle }) }) })), _jsxs(Dialog, { open: isOpen, onClose: () => {
                    if (showDialogButtons && !sectionError)
                        onCloseHandler();
                }, children: [_jsx(DialogTitle, { children: sectionTitle }), _jsx(DialogContent, { children: _jsx(Section, { ...rest }) }), showDialogButtons && !sectionError && (_jsx(DialogActions, { children: _jsx(Button, { onClick: onCloseHandler, color: "primary", children: intl.formatMessage(messages.closeDialogButtonLabel) }) }))] })] }));
};
DialogSection.displayName = "DployDialogSection";
export { DialogSection };
//# sourceMappingURL=DialogSection.js.map